import ServicesModal from "./ServicesModal";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { hideMessage, saveServicesDataAsync, deleteServicesDataAsync } from "../../utils/customer/servicesSlice";
import { useNavigate, useParams } from "react-router-dom";
import useRequireAuth from "../../utils/useRequireAuth";
import useFullscreen from "../../hooks/Screen/FullCloseScreen";
import CustomerListTable from "./CustomerListTable";
import serviceHeader from "./cusromerServiceData";
import { useCustomerTableMutation } from "../../utils/customer/customerTable";
import FirstMessage from "../GlobalFeature/MessageAlert/FirstMessage";
import {
  useAddUpdateCustomerServiceMutation,
  useAddupdateOrgServicesMutation,
  useDeleteServiceMutation,
  useGetCustomerServicesQuery,
} from "../../utils/customer/customerTaskTable";
import { useUpdateCustomerServiceTableDataMutation } from "../../utils/customer/customerTaskTable";
import { pushAlert } from "../../utils/alertSlice";
import Loader from "../UniversalComponents/Loader";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import PlusIcon from "../../assets/images/icons/PlusIcon";
import ReactTableComponent from "../UniversalComponents/ReactTableComponent";
import DeleteIcon from "../../assets/images/icons/deleteIcon";
import { ReactComponent as NoServiceIcon } from "../../assets/images/NoServiceIcon.svg";

const CustomerServices = ({ leftTab }) => {
  const dispatch = useDispatch();
  const { token } = useRequireAuth();
  const { id: customerId } = useParams();
  const [servicesData, setServicesData] = useState([]);
  const message = useSelector((state) => state.customerServices.message);
  const showMessage = useSelector((state) => state.customerServices.showMessage);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const [isHovered, setIsHovered] = useState(false);

  // *************** uncomment to add Delete coloum****************

  // const [deleteService, { isLoading, isError, isSuccess }] = useDeleteServiceMutation();

  // const handleDelete = async (rowKey) => {
  //   const id = rowKey?.id;
  //   try {
  //     const response = await dispatch(deleteService({ id, token })).unwrap();
  //     refetchCustomerData();
  //     dispatch(pushAlert({ visible: true, message: response?.message, type: "success" }));
  //   } catch (error) {
  //     console.error("Error deleting data:", error);
  //     dispatch(pushAlert({ visible: true, message: error?.message || "Error deleting data!", type: "danger" }));
  //   }
  // };

  const {
    data: customerServices,
    refetch: refetchCustomerData,
    isFetching: isFetchingCustomerData,
    isLoading: isLoadingServiceData,
    isError: isErrorServiceData,
  } = useGetCustomerServicesQuery(
    {
      token: token,
      customerId: customerId,
    },
    {
      skip: leftTab !== 1,
    }
  );

  console.log("isFetchingCustomerData", isFetchingCustomerData);

  const keysToExclude = [
    "customer_id",
    "service_id",
    "sub_service_id",
    "updated_at",
    "updated_by",
    "created_at",
    "created_by",
    "action",
    "descriptions",
  ];

  const [updateService, { isSuccess: isStatusUpdated, data }] = useAddUpdateCustomerServiceMutation();

  const onStatusClick = async (data) => {
    let CustomerServicePayload = {
      id: data.id,
      status: !data.status,
    };

    try {
      const response = await updateService({ CustomerServicePayload, token });

      if (response?.data?.success) {
        dispatch(pushAlert({ visible: true, message: response?.data?.message, type: "success" }));
      } else {
        dispatch(pushAlert({ visible: true, message: response?.data?.message, type: "danger" }));
      }
    } catch (error) {
      console.error("Error updating customer service:", error);
      dispatch(pushAlert({ visible: true, message: error.message || "An error occurred", type: "danger" }));
    }
  };

  useEffect(() => {
    if (isStatusUpdated) refetchCustomerData();
  }, [isStatusUpdated]);

  const createColumnDefinitions = (data, handleNavigate) => {
    if (!Array.isArray(data) || data.length === 0) {
      console.error("Invalid data provided");
      return [];
    }

    const firstObject = data[0];

    const keys = Object.keys(firstObject)
      .filter((key) => !keysToExclude.includes(key))
      .slice(1);

    return keys.map((key) => {
      // Remove "_name" from the key if present
      const formattedKey = key.replace(/_name$/, "");

      return {
        accessor_key: key,
        label: formattedKey
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        ...(key === "status" && {
          callingFunction: onStatusClick,
          boolColumn: true,
          boolState: {
            trueState: "Active",
            falseState: "Inactive",
          },
        }),
        // ...((key === "service_name" || key === "sub_service_name") && {
        //   callingFunction: handleNavigate,
        // }),

        EditHover: (
          <span className="w-full flex item-centre justify-end">
            <i className="bi bi-pencil"></i>
          </span>
        ),
      };
    });
  };

  const ManageListHeader = createColumnDefinitions(servicesData);
  console.log("ManageListHeadervinay", ManageListHeader);
  const memoizedData = useMemo(() => customerServices?.data || [], [customerServices]);

  useEffect(() => {
    if (customerServices) {
      setServicesData(memoizedData);
    }
  }, [memoizedData]);

  const [
    CustomerTableDrop,
    { data: customerCommnData, refetch: refetchCustomerCommnData, isLoading, headerError, headerLoading },
  ] = useCustomerTableMutation();

  const fetchCustomerTable = (data) => {
    const completedata = {
      model_name: "customer_services",
      field_name: data,
    };
    CustomerTableDrop({ token: token, data: completedata });
  };

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  useEffect(() => {
    if (!isPopupOpen) {
      setIsHovered(false);
    }
  }, [isPopupOpen]);

  const closePopup = () => {
    setIsPopupOpen(false);
  };
  setTimeout(() => {
    dispatch(hideMessage());
  }, 2000);

  const navigate = useNavigate();
  const handleNavigate = (customer_id = null) => {
    navigate(`/customer`);
  };

  useEffect(() => {
    if (isFetchingCustomerData) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [isFetchingCustomerData]);

  return (
    <>
      <div className="tablemaindiv h-full">
        <div className={`h-full`}>
          {showMessage && <p className="text-green-500 text-right">{message}</p>}

          <ReactTableComponent
            tablename={"Services"}
            // columnOrder={["service_name", "sub_service_name"]}
            headers={ManageListHeader}
            body={servicesData}
            onRowClick={(data) => console.log("userID kl", data)}
            actionField={
              <div className="flex gap-3 items-center">
                <button onClick={openPopup} type="button" className="text-2541558A hover:text-254155">
                  <PlusIcon isActive={isPopupOpen} />
                </button>
              </div>
            }
            apiStates={{
              body: {
                isLoading: isFetchingCustomerData,
                isError: isErrorServiceData,
              },
            }}
            alternateDivs={{
              emptyData: (
                <div className="w-full h-full">
                  <div className="flex justify-center items-center flex-col space-y-2 h-full ">
                    <NoServiceIcon className="h-[300px] w-[300px]" />
                    <span className="text-14 text-black text-sm font-400 font-poppins ">No Service is Available.</span>
                    {/* <span
                    onClick={() => openPopup()}
                    className="border px-5 py-1  bg-white cursor-pointer items-center text-center text-base font-medium  hover:border-[#1D4469] hover:text-[#1D4469] text-[#383838] rounded-md shadow-[0px_1px_0px_0px_rgba(0,0,0,0.10)_inset,0px_0px_4px_0px_rgba(0,0,0,0.15)]"
                  >
                    + Add Service
                  </span> */}
                  </div>
                </div>
              ),
            }}

            //**************Uncomment for Delete *************** */
            // actionColumn={(item) => {
            //   return (
            //     <div key={item?.id}>
            //       <button className="ml-2 pt-2" onClick={() => handleDelete(item)}>
            //         <DeleteIcon color={"red"} size={22} />
            //       </button>
            //     </div>
            //   );
            // }}
          />

          {isPopupOpen && (
            <div className="absolute  top-0 left-0 w-full flex justify-center items-center">
              <ServicesModal isOpen={isPopupOpen} onClose={closePopup} refetchCustomerData={refetchCustomerData} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CustomerServices;
